import React, { Component } from 'react';
import { Checkbox } from 'antd'
import { permissions } from './../../../../../../constants'
import handlePermission from './../../../../../app/handlePermission'
import './styles.css'

const PROHIBITED_TITLE_LIST = [
    {
        key: 'SKU',
        value: 'SKU'
    },
    {
        key: 'ItemCode',
        value: 'Channel Item Code'
    },
    {
        key: 'ItemName_US',
        value: 'ITEM NAME-EN'
    },
    {
        key: 'ItemName_JP',
        value: 'ITEM NAME-JP'
    },
    {
        key: 'CountryOfOriginCH',
        value: 'Origin'
    },
]

class HeaderItemNameProhibited extends Component {
    constructor(props) {
        super(props)
        this.state = {
            setPermission: !handlePermission(permissions.ItemNameUpdateItemName) ? true : false
        }
    }

    render() {
        const { handleSort, sortParams, collectIdItemCurrent } = this.props

        return (
            <thead className="item-name-header-container">
                <tr>
                    <th className='checkbox-prohibited'>
                        <Checkbox
                            onChange={(e) => this.props.onChangeCheckedAll(e.target.checked)}
                            checked={this.props.valueCheckox}
                            disabled={this.props.NumberProhibited === 0}
                        />
                        <span className="title-ignore-approve">IGNORE/APPROVE</span>
                    </th>
                    {
                        PROHIBITED_TITLE_LIST.map(item => (
                            <th key={item.key} className='col-title-item-name'>
                                <span className="title-container">
                                    {item.value}
                                </span>
                            </th>
                        ))
                    }
                </tr>
            </thead>
        );
    }
}

export default HeaderItemNameProhibited;


// WEBPACK FOOTER //
// ./src/containers/setting/setting-merchant/components/prohibited-items/header-prohibited-item-name/index.js